import { runDemo } from "../shared/demoRunner";
import { createFogScene } from "./scene";

runDemo({
    createScene: createFogScene,
});
